import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

const rotatingServices = [
  "Home Cleaning",
  "Office Cleaning"
];

export default function HeroVideo() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % rotatingServices.length);
    }, 2600);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative w-full min-h-[100svh] overflow-hidden">

      {/* VIDEO BACKGROUND */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src="/bg.mp4" type="video/mp4" />
      </video>

      {/* OVERLAY */}
      <div className="absolute inset-0  z-[1]" />

      {/* FLOATING SHAPES */}
      <motion.img
        src="https://www.svgrepo.com/show/353655/blob.svg"
        className="absolute top-[-120px] right-[-120px] w-[380px] opacity-20 z-[2]"
        animate={{ y: [0, 30, 0], rotate: [0, 10, 0] }}
        transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
      />

      <motion.img
        src="https://www.svgrepo.com/show/353655/blob.svg"
        className="absolute bottom-[-150px] left-[-150px] w-[420px] opacity-15 z-[2]"
        animate={{ y: [0, -40, 0], rotate: [0, -12, 0] }}
        transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* CONTENT */}
      <div className="relative z-10 flex min-h-[100svh] items-center">
        <div className="px-4 sm:px-6 md:px-10 max-w-2xl text-white">

          {/* BADGE */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="inline-flex items-center gap-2 border-1 border-[black] font-bold text-[#e58505] px-4 py-2 rounded-full text-xs sm:text-sm  mb-4"
          >
            <span className="w-2 h-2 bg-yellow-400 rounded-full animate-pulse"></span>
            THE SAFAI WALA
          </motion.div>

          {/* HEADING */}
          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="
              text-3xl 
              sm:text-4xl 
              md:text-5xl 
              lg:text-6xl 
              xl:text-7xl 
              font-extrabold 
              leading-tight
            "
          >
            Making Every{" "}
            <span className="relative inline-block h-[1.25em] min-w-[300px] align-middle overflow-visible">

              <AnimatePresence mode="wait">
                <motion.span
                  key={rotatingServices[index]}
                  initial={{ y: "100%", opacity: 0 }}
                  animate={{ y: "0%", opacity: 1 }}
                  exit={{ y: "-100%", opacity: 0 }}
                  transition={{ duration: 0.6, ease: "easeInOut" }}
                  className="absolute left-0 top-0 text-[#e58505] whitespace-nowrap"
                >
                  {rotatingServices[index]}
                
                 
                </motion.span>
              </AnimatePresence>

            </span>{" "}
            
          </motion.h1>

          {/* DESCRIPTION */}
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
            className="mt-4 text-sm sm:text-base md:text-lg text-gray-300 leading-relaxed"
          >
            Trusted professionals delivering spotless cleaning with care,
            precision, and eco-friendly solutions for every space.
          </motion.p>

          {/* APP STORE BUTTONS (RESTORED) */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8 }}
            className="mt-6 flex flex-wrap items-center gap-4"
          >
            <motion.a
              whileHover={{ scale: 1.08 }}
              whileTap={{ scale: 0.95 }}
              href="https://apps.apple.com/in/app/the-safai-wala/id6755910406"
              target="_blank"
              className="w-36 h-14"
            >
              <img
                src="/download-on-the-app-store.svg"
                alt="App Store"
                className="w-full h-full object-contain"
              />
            </motion.a>

            <motion.a
              whileHover={{ scale: 1.08 }}
              whileTap={{ scale: 0.95 }}
              href="https://play.google.com/store/apps/details?id=com.yashrajsingh163.thesafaiwala"
              target="_blank"
              className="w-40 h-14"
            >
              <img
                src="/Google_Play_Store_badge_EN.svg"
                alt="Google Play"
                className="w-full h-full object-contain"
              />
            </motion.a>
          </motion.div>

        </div>
      </div>
    </section>
  );
}
